import React, {useState, useEffect } from 'react';
import Formulario from './NotaDebitoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

function NotaDebito(props) {
    const { 
        lectura, listarDistribuidor, listarTiposGasto, agregarLinea, 
        detalleDocN, detalleND, eliminarLinea, eliminarLineaNota,
        loader, modulo, periodoD, registroNotaDebito, agregarNuevaLinea,
        modificarNotaDebito, buscarCuenta, cuentaContable, gastos,
        distribuidorCC, nombre_centro_costo, listarDistribuidorCC
    } = props;
        
    useEffect(() => {
        const { match, leer, getModulo, leerPeriodoD, 
            limpiar, listarTiposGasto } = props;
        const id = match.params.id;
        if (id){
            setCrear(false);
            leer(id);
        }
        let ruta = window.location.href;
        let cuenta = ruta.split('/');
        leerPeriodoD(cuenta[5], cuenta[7]);
        getModulo(cuenta[5], cuenta[4]);
        limpiar();
        listarTiposGasto();
        listarDistribuidorCC();
    }, [])
    const [crear, setCrear] = useState(true);
    return (
        <React.Fragment>
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    periodoD={periodoD}
                    lectura = {lectura}
                    listarDistribuidor = {listarDistribuidor}
                    listarTiposGasto = {listarTiposGasto}
                    agregarLinea = {agregarLinea}
                    detalleDocN = {detalleDocN}
                    registroNotaDebito = {registroNotaDebito}
                    detalleND = {detalleND}
                    eliminarDocumento = {eliminarLinea}
                    eliminarLineaNota = {eliminarLineaNota}
                    agregarNuevaLinea = {agregarNuevaLinea}
                    modificarNotaDebito = {modificarNotaDebito}
                    buscarCuenta = {buscarCuenta}
                    cuentaContable = {cuentaContable}
                    gastos = {gastos}
                    distribuidorCC = {distribuidorCC}
                    nombre_centro_costo = {nombre_centro_costo}
                    list_distribuidor_cc = {listarDistribuidorCC}
                />
            </LoadMask>
        </React.Fragment>
    )

}
export default NotaDebito;


